/** @format */

const categories = [
  {
    id: 1,
    link: "/Fruits",
    title: "Fruits",
    image:
      "https://images.unsplash.com/photo-1610832958506-aa56368176cf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80",
  },
  {
    id: 2,
    link: "/Vegetables",
    title: "Vegetables",
    image:
      "https://images.unsplash.com/photo-1590779033100-9f60a05a013d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
  },
  {
    id: 3,
    link: "/Grains",
    title: "Grains",
    image:
      "https://images.unsplash.com/photo-1621956838481-f8f616950454?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
  },
  {
    id: 4,
    link: "/Cereals",
    title: "Cereals",
    image:
      "https://images.unsplash.com/photo-1614961233913-a5113a4a34ed?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
  },
  {
    id: 5,
    link: "/Coffee",
    title: "Coffee",
    image:
      "https://images.unsplash.com/photo-1511920170033-f8396924c348?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
  },
  {
    id: 6,
    link: "/Soft-drinks",
    title: "Soft Drinks",
    image:
      "https://images.unsplash.com/photo-1524802020103-aa46eaffcaa2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80",
  },
  {
    id: 7,
    title: "Bread",
    image:
      "https://images.unsplash.com/photo-1608198093002-ad4e005484ec?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3432&q=80",
  },
  {
    id: 8,
    link: "/Dairy",
    title: "Dairy",
    image:
      "https://images.unsplash.com/photo-1546445317-29f4545e9d53?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1302&q=80",
  },
  {
    id: 9,
    link: "/Alcohol",
    title: "Alcohol",
    image:
      "https://images.unsplash.com/photo-1587578104013-fc8fcaf8b513?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
  },
  {
    id: 10,
    link: "/Vegan",
    title: "Vegan",
    image:
      "https://images.unsplash.com/photo-1620189507195-68309c04c4d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80",
  },
];

export default categories;
